export default __webpack_public_path__ + "static/media/CNo.56-1.68202e1d.jpg";